import { Injectable } from "@angular/core";
import { TurnoService } from "./turno.service";
import { BehaviorSubject, Observable, catchError, delay, find, map, of, tap, throwError } from "rxjs";
import { Regra } from "src/app/models/regra";
import { CHANGE_REQUEST_TYPE, RequestChange } from "src/app/models/request-change";
import { Setor } from "src/app/models/setor";
import { Turno } from "src/app/models/turno";
import { HttpClient, HttpParams } from "@angular/common/http";
import { EndPoint, getEndpoint } from "src/app/models/endpoint";
import { LoadingService } from "../loading.service";
import { ScaleStore } from "../scale.store";
import { ScaleInUseService } from "../scale-in-use.service";
import { ItemColaborador, ItemColaboradorDTO } from "src/app/models/itens_colaboradores";
import { addColaborador, addColaboradorDTO } from "src/app/models/add-colaborador";

import { SolicitacaoTroca, Solicitacoes, StatusSolicitacao, StatusSolicitacaoItem, TipoSolicitacao } from "src/app/models/solicitacao-troca";

@Injectable()
export class TurnoHttpService extends TurnoService {
  constructor(
    private http: HttpClient,
    private loadingService: LoadingService,
    scaleStore: ScaleStore,
    protected override scaleInUse: ScaleInUseService,
  ) {
    super(scaleStore, scaleInUse);
  }

  private solicitacoesMock = [
    {
      colaboradoresDestinoPasse: [],
      criadoEm: '2025-01-01',
      destinoRemanejamento: null,
      id: '1',
      itemOrigem: {
        dataEscala: '2025-01-01',
        escalaPeriodoColaboradorId: 156,
        id: 1,
        setor: {
          ativo: true,
          cor: '#1FBAA4',
          escalaPeriodoId: 1,
          id: 335,
          nome: 'UTI GERAL',
          colaboradores: []
        },
        ponto: false,
        sobreaviso: false,
        turno: {
          ativo: true,
          cor: '#EFAA32',
          descricao: '',
          escalaId: 1,
          horaFim: '00:00',
          horaInicio: '00:00',
          id: 1,
          sigla: 'MN'
        },
        deleted: false,
      },
      itensDestinoTroca: [
        {
          itemColaborador: {
            dataEscala: '2025-01-01',
            escalaPeriodoColaboradorId: 157,
            id: 1,
            setor: {
              ativo: true,
              cor: '#DF3030',
              escalaPeriodoId: 335,
              id: 335,
              nome: 'UTI GERAL',
              colaboradores: []
            },
            ponto: false,
            sobreaviso: false,
            turno: {
              ativo: true,
              cor: '#FFD500',
              descricao: '',
              escalaId: 1,
              horaFim: '00:00',
              horaInicio: '00:00',
              id: 335,
              sigla: 'TD'
            },
            deleted: false,
          },
          status: StatusSolicitacaoItem.PENDENTE_GESTOR,
          atualizadoEm: '2025-01-01',
        }
      ],
      status: StatusSolicitacao.PENDENTE,
      tipoSolicitacao: TipoSolicitacao.TROCA,
      atualizadoEm: '',
    },
    {
      criadoEm: '2025-01-01',
      destinoRemanejamento: null,
      id: '2',
      itemOrigem: {
        dataEscala: '2025-01-01',
        escalaPeriodoColaboradorId: 156,
        id: 1,
        setor: {
          ativo: true,
          cor: '#1FBAA4',
          escalaPeriodoId: 1,
          id: 335,
          nome: 'UTI GERAL',
          colaboradores: []
        },
        ponto: false,
        sobreaviso: false,
        turno: {
          ativo: true,
          cor: '#EFAA32',
          descricao: '',
          escalaId: 1,
          horaFim: '00:00',
          horaInicio: '00:00',
          id: 1,
          sigla: 'MN'
        },
        deleted: false,
      },
      colaboradoresDestinoPasse: [
        {
          escalaPeriodoColaborador: {
            escalaPeriodoColaboradorId: 157
          },
          status: StatusSolicitacaoItem.PENDENTE_GESTOR,
          atualizadoEm: '2025-01-01',
        }
      ],
      itensDestinoTroca: [],
      status: StatusSolicitacao.PENDENTE,
      tipoSolicitacao: TipoSolicitacao.PASSAGEM,
      atualizadoEm: '',
    },
    {
      criadoEm: '2025-01-01',
      destinoRemanejamento: {
        data: '2025-01-20',
        setor: {
          ativo: true,
          cor: '#BC6138',
          escalaPeriodoId: 1,
          id: 335,
          nome: 'TRIAGEM',
          colaboradores: []
        },
        turno: {
          ativo: true,
          cor: '#BBCE10',
          descricao: '',
          escalaId: 1,
          horaFim: '00:00',
          horaInicio: '00:00',
          id: 1,
          sigla: '24H'
        },
      },
      id: '3',
      itemOrigem: {
        dataEscala: '2025-01-01',
        escalaPeriodoColaboradorId: 156,
        id: 1,
        setor: {
          ativo: true,
          cor: '#1FBAA4',
          escalaPeriodoId: 1,
          id: 335,
          nome: 'UTI GERAL',
          colaboradores: []
        },
        ponto: false,
        sobreaviso: false,
        turno: {
          ativo: true,
          cor: '#EFAA32',
          descricao: '',
          escalaId: 1,
          horaFim: '00:00',
          horaInicio: '00:00',
          id: 1,
          sigla: 'MN'
        },
        deleted: false,
      },
      colaboradoresDestinoPasse: [],
      itensDestinoTroca: [],
      status: StatusSolicitacao.PENDENTE,
      tipoSolicitacao: TipoSolicitacao.REMANEJAMENTO,
      atualizadoEm: '',
    }
  ] as SolicitacaoTroca[];

  public carregaTurnos(escalaId: number): Observable<Turno[]> {
    return this.http.get<Turno[]>(`${getEndpoint(EndPoint.ESCALA_PERIODO_TURNO_GET).replace('{escalaPeriodoId}',''+escalaId)}`).pipe(
      map((res) => {
        if (res) {
          return res;
        }
        return [];
      }),
      catchError((err: any) => {
        const message = "Erro ao carregar os turnos."
        this.loadingService.presentToast(message)
        return throwError(err);
      }),
      tap((res) => {
        this.scaleInUse.setTurnos(res);
      })
    )
  }

  public override criaTurno(turno: Turno): Observable<Turno> {
    return this.http.post<Turno>(`${getEndpoint(EndPoint.ESCALA_PERIODO_TURNO)}`, {
      ...turno,
      escalaPeriodoId: this.scaleInUse.getEscalaPeriodoId()
    })
      .pipe(
        map((res) => {
          if (res) {
            return res;
          }
          return {} as Turno;
        }),
        catchError((err: any) => {
          const message = "Erro ao criar um turno"
          this.loadingService.presentToast(message)
          return throwError(err);
        }),
        tap((res) => {
          this.scaleInUse.addTurno(res);
        })
      )
  }

  public override atualizarTurno(turnoId: number, newTurno: Turno): Observable<Turno> {
    return this.http.put<Turno>(`${getEndpoint(EndPoint.ESCALA_PERIODO_TURNO)}/${turnoId}`, {
      ...newTurno,
      escalaPeriodoId: this.scaleInUse.getEscalaPeriodoId(),
      id: turnoId
    })
      .pipe(
        map((res) => {
          if (res) {
            return res;
          }
          return {} as Turno;
        }),
        catchError((err: any) => {
          const message = "Erro ao atualizar o turno"
          this.loadingService.presentToast(message)
          return throwError(err);
        }),
        tap((res) => {
          this.scaleInUse.updateTurno(res);
        })
      )
  }

  public override filtrarTurno(turnoId: number): Observable<Turno> {
    throw new Error("Method not implemented.");
  }

  public override deletarTurno(turnoId: number): void {
    this.loadingService.presentLoading();
    this.http.delete(`${getEndpoint(EndPoint.ESCALA_PERIODO_TURNO)}/${turnoId}`)
      .pipe(
        tap(() => {
          this.loadingService.dismissLoading();
          this.loadingService.presentToast('Turno deletado com sucesso')
          this.scaleInUse.deleteTurno(turnoId);
          this.scaleInUse.deleteTurnoItens(turnoId);
        }),
        catchError((e) => {
          this.loadingService.dismissLoading();
          return throwError(e);
        })
      )
      .subscribe()
  }

  public override carregaSetores(escalaId: number): Observable<Setor[]> {
    return this.http.get<Setor[]>(`${getEndpoint(EndPoint.ESCALA_PERIODO_SETOR_GET).replace('{escalaPeriodoId}', escalaId.toString())}`).pipe(
      map((res) => {
        if (res) {
          return res;
        }
        return [];
      }),
      catchError((err: any) => {
        const message = "Erro ao carregar os setores."
        this.loadingService.presentToast(message)
        return throwError(err);
      }),
      tap((res) => {
        this.scaleInUse.setSetores(res);
      })
    )
  }

  public override criaSetor(setor: Setor,): Observable<Setor> {
    return this.http.post<Setor>(`${getEndpoint(EndPoint.ESCALA_PERIODO_SETOR)}`, {
      ...setor,
      escalaPeriodoId: this.scaleInUse.getEscalaPeriodoId()
    })
      .pipe(
        map((res) => {
          if (res) {
            return res;
          }
          return {} as Setor;
        }),
        catchError((err: any) => {
          const message = "Erro ao criar um setor"
          this.loadingService.presentToast(message)
          return throwError(err);
        }),
        tap((res) => {
          this.scaleInUse.addSetor(res);
        })
      )
  }

  public override atualizarSetor(setorId: number, newSetor: Setor): Observable<Setor> {
    return this.http.put<Setor>(`${getEndpoint(EndPoint.ESCALA_PERIODO_SETOR)}/${setorId}`, {
      ...newSetor,
      escalaPeriodoId: this.scaleInUse.getEscalaPeriodoId(),
      id: setorId
    })
      .pipe(
        map((res) => {
          if (res) {
            return res;
          }
          return {} as Setor;
        }),
        catchError((err: any) => {
          const message = "Erro ao atualizar o setor"
          this.loadingService.presentToast(message)
          return throwError(err);
        }),
        tap((res) => {
          this.scaleInUse.updateSetor(res);
        })
      )
  }

  public override filtrarSetor(setorId: number): Observable<Setor> {
    throw new Error("Method not implemented.");
  }

  public override deletarSetor(setorId: number): void {
    this.loadingService.presentLoading();
    this.http.delete(`${getEndpoint(EndPoint.ESCALA_PERIODO_SETOR)}/${setorId}`)
      .pipe(
        tap(() => {
          this.loadingService.dismissLoading();
          this.loadingService.presentToast('Setor deletado com sucesso')
          this.scaleInUse.deleteSetor(setorId);
          //this.scaleInUse.removeSetorInEscaleInUse(setorId);
        }),
        catchError((e) => {
          this.loadingService.dismissLoading();
          return throwError(e);
        })
      )
      .subscribe()
  }

  public override carregaSetorPorEscala(escalaId: number, setorId: number): Observable<Setor> {
    return this.http.get<Setor>(`${getEndpoint(EndPoint.ESCALA_PERIODO_SETOR)}/${setorId}?escalaId=${escalaId}`).pipe(
      map((res) => {
        if (res) {
          return res;
        }
        return {} as Setor;
      }),
      catchError((err: any) => {
        const message = "Erro ao carregar o setor."
        this.loadingService.presentToast(message)
        return throwError(err);
      })
    )
  }

  public override criaSolicitacaoTroca(solicitacao: RequestChange): Observable<RequestChange> {
    return this.http.post<RequestChange>(`${getEndpoint(EndPoint.SOLICITACAO_TROCA)}`, solicitacao)
      .pipe(
        map((res) => {
          if (res) {
            return res;
          }
          return {} as RequestChange;
        }),
        catchError((err: any) => {
          const message = "Erro ao criar uma solicitação de troca"
          this.loadingService.presentToast(message)
          return throwError(err);
        })
      )
  }

  public override carregarSolicitacoesTroca(escalaId: number): Observable<Solicitacoes> {
    return of(this.solicitacoesMock).pipe(
      delay(1000),
      map((response) => {
        const concretizadas = response.filter((item) => item.status != StatusSolicitacao.PENDENTE);
        const pendentes = response.filter((item) => item.status == StatusSolicitacao.PENDENTE);

        return {
          concretizadas,
          pendentes
        }
      })
    )
    // return this.http.get<RequestChange[]>(`${getEndpoint(EndPoint.SOLICITACAO_TROCA)}?escalaId=${escalaId}`)
    //   .pipe(
    //     map((res) => {
    //       if (res) {
    //         return res;
    //       }
    //       return [];
    //     }),
    //     catchError((err: any) => {
    //       const message = "Erro ao carregar solicitações de troca"
    //       this.loadingService.presentToast(message)
    //       return throwError(err);
    //     })
    //   )
  }

  public override recusarSolicitacaoTroca(solicitacaoId: string): Observable<any> {
    return of({}).pipe(
      tap(() => {
        const findIndex = this.solicitacoesMock.findIndex((solicitacao) => solicitacao.id == solicitacaoId);

        if(findIndex != -1) {
          this.solicitacoesMock[findIndex].status = StatusSolicitacao.REJEITADA
        }
      }),
      delay(2000)
    )
  }

  public override aprovarSolicitacaoTroca(solicitacaoId: string): Observable<any> {
    return of({}).pipe(
      tap(() => {
        const findIndex = this.solicitacoesMock.findIndex((solicitacao) => solicitacao.id == solicitacaoId);

        if(findIndex != -1) {
          this.solicitacoesMock[findIndex].status = StatusSolicitacao.APROVADA
        }
      }),
      delay(2000)
    )
  }

  public override atualizarItemColaborador(itemId: number, newItem: ItemColaboradorDTO): Observable<ItemColaborador> {
    return this.http.put<ItemColaborador>(`${getEndpoint(EndPoint.ITEM_COLABORADOR)}/${itemId}`, {
      ...newItem
    })
  }

  public override criaItemColaborador(item: ItemColaboradorDTO): Observable<ItemColaborador> {
    //TODO API
    return this.http.post<ItemColaborador>(`${getEndpoint(EndPoint.ITEM_COLABORADOR)}`, {
      ...item
    })
  }

  public override deletarItemColaborador(itemId: number): void {
    //TODO API
    this.http.delete(`${getEndpoint(EndPoint.ITEM_COLABORADOR)}/${itemId}`)
      .pipe(
        tap(() => {
          this.loadingService.dismissLoading();
          this.loadingService.presentToast('Itens deletados com sucesso')
        }),
        catchError((e) => {
          this.loadingService.dismissLoading();
          return throwError(e);
        })
      )
      .subscribe()
    return
  }

  public override deletarItensColaborador(itens: number[]): void {
    this.http.delete(`${getEndpoint(EndPoint.ITEM_COLABORADOR)}/lista`, {
      body: itens
    })
      .pipe(
        tap(() => {
          this.loadingService.dismissLoading();
          this.loadingService.presentToast('Itens deletados com sucesso')
        }),
        catchError((e) => {
          this.loadingService.dismissLoading();
          return throwError(e);
        })
      )
      .subscribe()
  }

  public override adicionarColaborador(colaboradorData: addColaboradorDTO): Observable<addColaborador> {
    return this.http.post<addColaborador>(`${getEndpoint(EndPoint.ESCALA_PERIODO_COLABORADORES)}`, colaboradorData)
      .pipe(
        map((res) => {
          if (res) {
            return res;
          }
          return {} as addColaborador;
        }),
        catchError((err: any) => {
          const message = "Erro ao adicionar colaborador"
          this.loadingService.presentToast(message)
          return throwError(err);
        })
      )
  }

  public override carregaSetoresPeriodo(escalaPeriodo: number): Observable<Setor[]> {
    return this.http.get<Setor[]>(`${getEndpoint(EndPoint.ESCALA_PERIODO)}/${escalaPeriodo}/setores`).pipe(
      map((res) => {
        if (res) {
          return res;
        }
        return [];
      }),
      catchError((err: any) => {
        const message = "Erro ao carregar os setores."
        this.loadingService.presentToast(message)
        return throwError(err);
      }),
      tap((res) => {
        this.scaleInUse.setSetores(res);
      })
    )
  }

  public carregaSetoresEscalaPai(escala: number): Observable<Setor[]> {
    return this.http.get<Setor[]>(`${getEndpoint(EndPoint.ESCALA)}/${escala}/setores`).pipe(
      map((res) => {
        if (res) {
          return res;
        }
        return [];
      }),
      catchError((err: any) => {
        const message = "Erro ao carregar os setores."
        this.loadingService.presentToast(message)
        return throwError(err);
      })
    )
  }

  public override carregaTurnosPeriodo(escalaPeriodo: number): Observable<Turno[]> {
    return this.http.get<Turno[]>(`${getEndpoint(EndPoint.ESCALA_PERIODO)}/${escalaPeriodo}/turnos`).pipe(
      map((res) => {
        if (res) {
          return res;
        }
        return [];
      }),
      catchError((err: any) => {
        const message = "Erro ao carregar os turnos."
        this.loadingService.presentToast(message)
        return throwError(err);
      }),
      tap((res) => {
        this.scaleInUse.setTurnos(res);
      })
    )
  }
}
